<template>
  <div class="cmi00100-wrapper">
    <PageHeaderBanner>
      <template v-if="!isPasswordFlag" #title>会員情報</template>
      <template v-else #title>パスワード変更</template>
    </PageHeaderBanner>
    <!-- エラーメッセージの表示 -->
    <MessageChip :display="errMessageFlag" level="E" :message="errMessage" />
    <!-- 会員情報 -->
    <div class="cmi00100-form-area">
      <MemberDetailCard class="q-mb-lg" :data="mKaiin" mode="memberinfo" />
      <div class="q-mb-lg">
        <div v-if="!isPasswordFlag" class="cmi00100-password-form">
          <div class="row items-center">
            <div class="col text-right q-mr-md">
              <label>パスワード</label>
            </div>
            <div class="col-6">********</div>
            <div class="col">
              <q-btn
                color="primary"
                width="200px"
                label="パスワード変更"
                @click="
                  (isPasswordFlag = true),
                    (isPwd1 = true),
                    (isPwd2 = true),
                    (isPwd3 = true),
                    (inputData.old_password = ''),
                    (inputData.new_password = ''),
                    (inputData.new_password_conf = '')
                "
              />
            </div>
          </div>
        </div>
      </div>
      <!-- パスワード変更 -->
      <q-form
        autofocus
        greedy
        novalidate
        @submit="isConfirmationFlag = true"
        @validation-error="resetError"
      >
        <div v-if="isPasswordFlag" class="cmi00100-password-form">
          <!-- パスワード入力フォーム -->
          <div class="password-chenger">
            <div class="col q-mb-sm">
              <label for="name" class="requier password-area">現在のパスワード</label>
              <q-input
                id="old_password"
                ref="old_password"
                v-model="inputData.old_password"
                :type="isPwd1 ? 'password' : 'text'"
                outlined
                maxlength="72"
                name="old_password"
                class="form-control input-area"
                th:field="*{old_password}"
                dense
                :rules="[(val) => isEmpty(val) || $t('validation.required')]"
                lazy-rules
                @keydown.enter.prevent
              >
                <template #append>
                  <q-icon
                    :name="isPwd1 ? 'visibility_off' : 'visibility'"
                    class="cursor-pointer"
                    @click="isPwd1 = !isPwd1"
                  />
                </template>
              </q-input>
            </div>
            <div class="col q-mb-sm">
              <label class="requier password-area">変更後のパスワード</label>
              <q-input
                id="new_password"
                ref="new_password"
                v-model="inputData.new_password"
                outlined
                :type="isPwd2 ? 'password' : 'text'"
                name="new_password"
                class="form-control input-area"
                maxlength="72"
                th:field="*{new_password}"
                dense
                :rules="[
                  (val) => isEmpty(val) || $t('validation.required'),
                  (val) => val !== inputData.old_password || $t('validation.same_password'),
                ]"
                lazy-rules
                @keydown.enter.prevent
              >
                <template #append>
                  <q-icon
                    :name="isPwd2 ? 'visibility_off' : 'visibility'"
                    class="cursor-pointer"
                    @click="isPwd2 = !isPwd2"
                  />
                </template>
              </q-input>
            </div>

            <div class="col q-mb-sm">
              <label class="requier password-area">変更後のパスワード（確認用）</label>
              <q-input
                id="new_password_conf"
                ref="new_password_conf"
                v-model="inputData.new_password_conf"
                outlined
                :type="isPwd3 ? 'password' : 'text'"
                name="new_password_conf"
                class="form-control input-area"
                maxlength="72"
                th:field="*{new_password_conf}"
                reactive-rules
                dense
                :rules="[
                  (val) => isEmpty(val) || $t('validation.required'),
                  (val) => val === inputData.new_password || $t('validation.same_new_password'),
                ]"
                lazy-rules
                @keydown.enter.prevent
              >
                <template #append>
                  <q-icon
                    :name="isPwd3 ? 'visibility_off' : 'visibility'"
                    class="cursor-pointer"
                    @click="isPwd3 = !isPwd3"
                  />
                </template>
              </q-input>
            </div>

            <div class="pass-info-box">
              ※パスワードは半角英数字混在の8文字以上で入力してください。
            </div>
          </div>
          <FormFooterBanner style="position: inherit">
            <template #button-area>
              <!-- 会員情報変更 -->
              <div v-if="!isPasswordFlag">
                <q-btn
                  color="primary"
                  style="width: 200px"
                  label="会員情報変更"
                  :to="{ name: 'memberinfoUpdate' }"
                />
              </div>
              <!-- パスワード入力画面 -->
              <div v-if="isPasswordFlag">
                <q-btn
                  outline
                  style="width: 120px; color: var(--q-delete)"
                  class="q-mr-xs back-button"
                  label="戻る"
                  @click="(isPasswordFlag = false), (errMessageFlag = false)"
                />
                <q-btn color="primary" type="chenge" style="width: 120px" label="変更" />
              </div>
            </template>
          </FormFooterBanner>
        </div>
      </q-form>
      <FormFooterBanner style="position: inherit">
        <template #button-area>
          <!-- 会員情報変更 -->
          <div v-if="mKaiin.auth_level === 'MEMBER' && !isPasswordFlag">
            <q-btn
              color="primary"
              style="width: 200px"
              label="会員情報変更"
              :to="{ name: 'memberinfoUpdate' }"
            />
          </div>
        </template>
      </FormFooterBanner>
    </div>
    <!-- 更新確認ダイアログ -->
    <AlertDialog
      :display="isConfirmationFlag"
      level="information"
      title="更新確認"
      :text="['入力された内容で更新します。', 'よろしいですか？']"
      @confirm="passChenge()"
      @close="isConfirmationFlag = false"
    />
    <!-- 更新完了ダイアログ -->
    <AlertDialog
      :display="isUpdateFlag"
      level="information"
      confirmation
      title="更新完了"
      :text="['更新が完了しました。']"
      @complete="isUpdateFlag = false"
    />
  </div>
</template>
<script setup lang="ts">
import { reactive, ref } from 'vue';
import { useRouter } from 'vue-router';
import { Loading } from 'quasar';
import axios from 'axios';
import AlertDialog from '../../components/dialogs/AlertDialog.vue';
import MemberDetailCard from '../../components/card/MemberDetailCard.vue';
import FormFooterBanner from '../../components/banner/FormFooterBanner.vue';
import PageHeaderBanner from '../../components/banner/PageHeaderBanner.vue';
import ResultStatusCode from '../../common/code/ResultStatusCode';
import HttpResponseStatusCode from '../../common/code/HttpResponseStatusCode';
import MessageChip from '../../components/chip/MessageChip.vue';
import { isEmpty } from '../../common/utils/validateUtils';

const router = useRouter();
// パスワード変更フラグ
const isPasswordFlag = ref(false);
// パスワード変更確認フラグ
const isConfirmationFlag = ref(false);
// パスワード変更完了フラグ
const isUpdateFlag = ref(false);
// エラーメッセージ
const errMessage = ref('');
// エラーメッセージフラグ
const errMessageFlag = ref(false);
// 会員情報
const mKaiin = ref({
  approval_stat: '',
  auth_level: '',
  user_id: '',
  user_name_mei: '',
  user_name_sei: '',
  customer_cd: '',
  mail_address: '',
  phone_number: '',
  work_school_name: '',
  affiliation_department_name: '',
  postal_cd: '',
  todohuken_name: '',
  street_address: '',
  quote_request_mail1: '',
  quote_request_mail2: '',
  quote_request_mail3: '',
  quote_request_mail4: '',
  update_timestamp: '',
  user_attribute: '',
});
// 入力値
const inputData = reactive({
  old_password: '',
  new_password: '',
  new_password_conf: '',
});

// パスワードマスキングフラグ
const isPwd1 = ref(true);
// パスワードマスキングフラグ
const isPwd2 = ref(true);
// パスワードマスキングフラグ
const isPwd3 = ref(true);

/**
 * エラーチップを初期化
 */
const resetError = async () => {
  errMessage.value = '';
  errMessageFlag.value = false;
};

/**
 * 会員情報取得
 */
const getMemberInfo = async () => {
  // Loading Start
  Loading.show();
  // 会員情報取得
  await axios
    .post('/cmi001001/memberInfo')
    .then((res) => {
      const { common } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          mKaiin.value = res.data.mkaiin;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          router.push({ name: 'error' });
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.res.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};
/**
 * パスワード変更処理
 */
const passChenge = async () => {
  isConfirmationFlag.value = false;
  // Loading Start
  Loading.show();

  errMessage.value = '';
  errMessageFlag.value = false;
  // 変更データ作成
  const formData = new FormData();
  formData.append('old_password', inputData.old_password);
  formData.append('new_password', inputData.new_password);
  formData.append('new_password_conf', inputData.new_password_conf);
  await axios
    .post('/cmi001002/edit-password', formData)
    .then((res) => {
      const { common } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          errMessage.value = '';
          errMessageFlag.value = false;
          isPasswordFlag.value = false;
          // ダイアログ表示
          isUpdateFlag.value = true;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          // エラーメッセージ表示
          errMessage.value = common.message;
          errMessageFlag.value = true;
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.res.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

// 初期表示処理
getMemberInfo();
</script>
<style scoped>
.cmi00100-form-area {
  width: 80%;
  max-width: 1020px;
  margin: 0 auto;
}
.cmi00100-password-form {
  width: 70%;
  margin: 0 auto;
}
.cmi00100-password-form .password-chenger {
  width: 650px;
  margin: 0 auto;
}
.cmi00100-password-form .col {
  font-weight: 600;
}
.cmi00100-password-form .password-area {
  letter-spacing: 1px;
}
</style>
<style>
.cmi00100-wrapper .message-chip .q-chip {
  margin-bottom: 8px;
}
</style>
